import React from "react";
import { ProductScore } from "../../store/score/getProductScore";
import { Badge } from "../../components/ui/badge";
import { useTranslation } from "../../i18n/hooks";

const ProductQualityImprovement = ({productScore}: {productScore: ProductScore}): React.JSX.Element => {
    const { t } = useTranslation();
    return (
      <div className="flex items-center flex-wrap gap-2 mt-1">
        <span className="text-sm text-gray-500 whitespace-nowrap">
          {t('jobsView.quality_improvement')}
        </span>
        <Badge
          className={`${
            productScore.totalImprovement > 0
              ? "bg-green-50 text-green-700 hover:bg-green-50"
              : productScore.totalImprovement < 0
                ? "bg-red-50 text-red-700 hover:bg-red-50"
                : "bg-gray-50 text-gray-700 hover:bg-gray-50"
          } whitespace-nowrap`}
        >
          {productScore.totalImprovement > 0 ? "+" : ""}
          {productScore.totalImprovement.toFixed(0)}%
        </Badge>
      </div>
    );
  };

  export default ProductQualityImprovement;